module.exports = __webpack_public_path__ + "static/newsletter_wave-7dfc45d1c12b2018a3cbceadcb58f39b.svg";